import styled from "@emotion/styled"
import { FlexContainer, FlexContainerAndItem } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"

export const TradingPageScroller = styled(FlexContainer)({
  gridArea: "content",
  height: "100%",
  width: "100%",
  overflow: "auto",
  scrollSnapType: "y mandatory",
  scrollBehavior: "smooth",
})

export const TradingWavePageContainer = styled(FlexContainer)({
  height: "300%",
  width: "100%",
  padding: "15px 25px 10px 25px",
  gap: "20px",
})

export const FullHeightOrdersContainer = styled(FlexContainerAndItem)({
  width: "100%",
  height: "33%",
  minHeight: "33%",
  display: "flex",
  paddingTop: "10px",
  flexDirection: "column",
  gap: "20px",
  scrollSnapAlign: "start",
  scrollSnapStop: "always",
})

export const OrdersTableSection = styled(FlexContainerAndItem)({
  width: "100%",
  height: "33%",
  minHeight: "33%",
  scrollSnapAlign: "start",
  scrollSnapStop: "always",
  paddingTop: "10px",
})

export const WavesSection = styled(FlexContainerAndItem)({
  width: "100%",
  height: "33%",
  minHeight: "33%",
  paddingBottom: "10px",
  backgroundColor: SCIENT_COLORS.darkGray2,
  borderRadius: "6px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
  overflow: "hidden",
  scrollSnapAlign: "start",
  scrollSnapStop: "always",
})

// Quick navigation dots
export const QuickNav = styled(FlexContainer)({
  position: "fixed",
  right: "10px",
  top: "50%",
  transform: "translateY(-50%)",
  flexDirection: "column",
  gap: "15px",
  zIndex: 1000,
  backgroundColor: SCIENT_COLORS.darkGray4,
  padding: "12px 8px",
  borderRadius: "12px",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)",
})

export const NavDot = styled.button<{ active: boolean }>(({ active }) => ({
  width: "12px",
  height: "12px",
  borderRadius: "50%",
  border: "none",
  backgroundColor: active ? SCIENT_COLORS.blue1 : SCIENT_COLORS.darkGray3,
  cursor: "pointer",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "scale(1.2)",
    backgroundColor: active ? SCIENT_COLORS.blue1 : SCIENT_COLORS.darkGray2,
  },
}))
